import { render, staticRenderFns } from "./SmplEditMain.vue?vue&type=template&id=1b6b0033&scoped=true&"
import script from "./SmplEditMain.vue?vue&type=script&lang=js&"
export * from "./SmplEditMain.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditMain.vue?vue&type=style&index=0&id=1b6b0033&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6b0033",
  null
  
)

export default component.exports